/**
 * Single source of truth for the disposal prohibited-items list, shared across
 * the monorepo (public website booking flow + admin phone-in placement script).
 * The customer acknowledges this exact list online; the phone agent reads the
 * same list. Keep it here so the two never drift.
 *
 * Imported via relative path from both packages (like shared/regions.ts); each
 * package's tsconfig includes `../shared/**\/*.ts`, so no workspace package
 * import is needed.
 */

export const PROHIBITED_ITEMS = [
  'Mattresses',
  'Paint',
  'Tires',
  'Batteries',
  'Asbestos',
  'Harmful chemicals',
  'Flammable liquids',
  'Other environmental hazards',
] as const;

/** The acknowledgment statement the customer agrees to (website) / confirms
 *  over the phone (admin). */
export const PROHIBITED_ITEMS_ACK =
  'By checking this box, I acknowledge that the items listed above are prohibited or may incur additional disposal fees.';
